module.exports = __webpack_public_path__ + "static/media/Jefferson Properties - Court Order appointing receiver.02872907.pdf";